import React, { useEffect, useState, useContext } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../App';
import Layout from '../components/Layout';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ConfirmEmailChangePage() {
  const [params] = useSearchParams();
  const { fetchUser } = useContext(AuthContext);
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [newEmail, setNewEmail] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No confirmation token provided.');
      return;
    }
    axios.get(`${API}/auth/confirm-email-change?token=${token}`)
      .then(res => {
        setStatus('success');
        setMessage(res.data.message);
        setNewEmail(res.data.new_email);
        if (fetchUser) fetchUser();
      })
      .catch(err => { setStatus('error'); setMessage(err.response?.data?.detail || 'Confirmation failed.'); });
  }, [params]);

  return (
    <Layout>
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="confirm-email-change-page">
        <div className="bg-card border border-border rounded-sm p-10 max-w-md w-full text-center">
          {status === 'loading' && (
            <>
              <Loader2 className="h-12 w-12 text-[#78BE20] mx-auto animate-spin mb-4" />
              <p className="text-muted-foreground">Confirming email change...</p>
            </>
          )}
          {status === 'success' && (
            <>
              <CheckCircle2 className="h-16 w-16 text-[#78BE20] mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-foreground mb-2">Email Updated!</h1>
              <p className="text-muted-foreground mb-2">{message}</p>
              {newEmail && <p className="text-foreground font-medium mb-6">New email: {newEmail}</p>}
              <p className="text-sm text-muted-foreground mb-6">Please log in again with your new email address.</p>
              <Link to="/login">
                <Button className="bg-[#78BE20] text-black hover:bg-[#65a31b]" data-testid="go-to-login-btn">
                  Go to Login
                </Button>
              </Link>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-foreground mb-2">Confirmation Failed</h1>
              <p className="text-muted-foreground mb-6">{message}</p>
              <Link to="/account">
                <Button variant="outline" className="border-zinc-700">Go to Account</Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
}
